/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-03 11:44:40
 */
/**
 * 系统管理 Saga集合
 */
import distributionorder from './distributionorder/model';
import serviceorder from './serviceorder/model';
import insuranceorder from './insuranceorder/model';
import virtualno from './virtualno/model';
import microshippingorder from './microshippingorder/model';

export default [
    ...Object.values(distributionorder.sagas), // 配送订单
    ...Object.values(serviceorder.sagas),//增值服务订单
    ...Object.values(insuranceorder.sagas),//保单
    ...Object.values(virtualno.sagas),//虚拟号
    ...Object.values(microshippingorder.sagas),//微企订单
];
